(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    const showError = (msg) => {
      const el = drawer.querySelector('[data-cart-drawer-error]');
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
    };

    const hideError = () => {
      const el = drawer.querySelector('[data-cart-drawer-error]');
      if (!el) return;
      el.textContent = '';
      el.hidden = true;
    };

    const sectionId = drawer.dataset.sectionId;
    const root = window.Shopify?.routes?.root || '/';

    const getPanel = () => drawer.querySelector('[data-cart-drawer-content]');

    const getNoteValue = () => drawer.querySelector('[data-cart-drawer-note]')?.value ?? '';

    let noteSaveTimeout;

    const saveNote = async () => {
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ note: getNoteValue() }),
      });

      return response.ok;
    };

    const updateCartCount = async () => {
      const response = await fetch(`${root}cart.js`);
      if (!response.ok) return;

      const cart = await response.json();

      document.querySelectorAll('[data-cart-count]').forEach((element) => {
        element.textContent = cart.item_count;
        element.hidden = cart.item_count === 0;
      });
    };

    const loadRecommendations = async () => {
      const container = drawer.querySelector('[data-cart-drawer-recommendations]');
      const list = drawer.querySelector('[data-cart-drawer-recommendations-list]');
      const templateSection = document.querySelector('[data-cart-drawer-recommendations-template]');

      if (!container || !list || !templateSection) return;

      const recSectionId = templateSection.dataset.sectionId;
      const limit = container.dataset.limit || 4;
      const intent = container.dataset.intent || 'complementary';

      const cartResponse = await fetch(`${root}cart.js`);
      if (!cartResponse.ok) return;

      const cart = await cartResponse.json();
      const lastItem = cart.items[cart.items.length - 1];

      if (!lastItem) {
        container.hidden = true;
        return;
      }

      const response = await fetch(
        `${root}recommendations/products?section_id=${recSectionId}&product_id=${lastItem.product_id}&limit=${limit}&intent=${intent}`
      );

      if (!response.ok) return;

      const html = await response.text();
      const template = document.createElement('template');
      template.innerHTML = html.trim();
      const apiList = template.content.querySelector('.cart-drawer__recommendations-list');

      if (apiList && apiList.children.length > 0) {
        list.innerHTML = apiList.innerHTML;
        container.hidden = false;
      } else if (list.children.length === 0) {
        container.hidden = true;
      } else {
        container.hidden = false;
      }
    };

    const refreshDrawer = async () => {
      const pendingNote = getNoteValue();

      const response = await fetch(`${root}?sections=${sectionId}`);
      if (!response.ok) return;

      const data = await response.json();
      const html = data[sectionId];
      if (!html) return;

      const template = document.createElement('template');
      template.innerHTML = html.trim();
      const nextPanel = template.content.querySelector('[data-cart-drawer-content]');
      const currentPanel = getPanel();

      if (nextPanel && currentPanel) {
        currentPanel.innerHTML = nextPanel.innerHTML;

        const noteField = drawer.querySelector('[data-cart-drawer-note]');
        if (noteField && noteField.value !== pendingNote) {
          noteField.value = pendingNote;
        }
      }

      await updateCartCount();
      await loadRecommendations();
    };

    const setLoading = (loading) => {
      drawer.classList.toggle('is-loading', loading);
    };

    const openDrawer = async () => {
      setLoading(true);

      try {
        await refreshDrawer();
      } finally {
        setLoading(false);
      }

      if (!drawer.open) {
        drawer.showModal();
      }
    };

    const closeDrawer = () => {
      if (drawer.open) {
        drawer.close();
      }
    };

    const changeLine = async (lineKey, quantity) => {
      setLoading(true);
      hideError();

      try {
        await saveNote();

        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: lineKey,
            quantity: Math.max(0, quantity),
          }),
        });

        if (!response.ok) {
          const err = await response.json();
          showError(err.description || 'Unable to update quantity');
          await refreshDrawer();
          return;
        }

        await refreshDrawer();
      } finally {
        setLoading(false);
      }
    };

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-drawer-open]')) {
        event.preventDefault();
        openDrawer();
        return;
      }

      if (event.target.closest('[data-cart-drawer-close]')) {
        event.preventDefault();
        closeDrawer();
      }
    });

    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) {
        closeDrawer();
      }
    });

    drawer.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDrawer();
    });

    drawer.addEventListener('click', (event) => {
      const removeButton = event.target.closest('[data-cart-line-remove]');
      if (removeButton) {
        changeLine(removeButton.dataset.lineKey, 0);
        return;
      }

      const minusButton = event.target.closest('[data-cart-quantity-minus]');
      if (minusButton) {
        const input = minusButton.closest('[data-cart-quantity]')?.querySelector('[data-cart-quantity-input]');
        if (input) {
          const next = Math.max(0, parseInt(input.value, 10) - 1);
          changeLine(input.dataset.lineKey, next);
        }
        return;
      }

      const plusButton = event.target.closest('[data-cart-quantity-plus]');
      if (plusButton) {
        const input = plusButton.closest('[data-cart-quantity]')?.querySelector('[data-cart-quantity-input]');
        if (input) {
          const max = input.dataset.maxQuantity ? parseInt(input.dataset.maxQuantity, 10) : Infinity;
          const next = Math.min(max, parseInt(input.value, 10) + 1);
          changeLine(input.dataset.lineKey, next);
        }
      }
    });

    drawer.addEventListener('change', (event) => {
      const input = event.target.closest('[data-cart-quantity-input]');
      if (!input) return;

      const max = input.dataset.maxQuantity ? parseInt(input.dataset.maxQuantity, 10) : Infinity;
      const val = Math.min(max, parseInt(input.value, 10) || 0);
      input.value = String(Math.max(0, val));
      changeLine(input.dataset.lineKey, parseInt(input.value, 10));
    });

    drawer.addEventListener('input', (event) => {
      if (!event.target.matches('[data-cart-drawer-note]')) return;

      clearTimeout(noteSaveTimeout);
      noteSaveTimeout = setTimeout(() => {
        saveNote();
      }, 400);
    });

    drawer.addEventListener(
      'blur',
      (event) => {
        if (event.target.matches('[data-cart-drawer-note]')) {
          saveNote();
        }
      },
      true
    );

    drawer.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('[data-cart-drawer-checkout]')) return;

      event.preventDefault();
      await saveNote();
      window.location.href = `${root}checkout`;
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = form.getAttribute('action') || '';
      if (!action.includes('/cart/add')) return;

      event.preventDefault();

      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton?.disabled) return;

      if (submitButton) submitButton.disabled = true;
      setLoading(true);

      try {
        const qtyInput = form.querySelector('[name="quantity"]');
        const variantIdInput = form.querySelector('[name="id"]');

        if (qtyInput?.dataset?.maxQuantity) {
          const max = parseInt(qtyInput.dataset.maxQuantity, 10);
          let requested = Math.max(1, parseInt(qtyInput.value, 10) || 1);

          if (variantIdInput) {
            const cartResponse = await fetch(`${root}cart.js`);
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              const existing = cart.items.find(item => String(item.variant_id) === String(variantIdInput.value));
              const inCart = existing ? existing.quantity : 0;
              const available = Math.max(0, max - inCart);

              if (requested > available) {
                if (available <= 0) {
                  await openDrawer();
                  showError('This item is already at the maximum quantity in your cart');
                  return;
                }
                requested = available;
              }
            }
          }

          if (requested !== parseInt(qtyInput.value, 10)) {
            qtyInput.value = String(Math.max(1, requested));
          }
        }

        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: new FormData(form),
        });

        if (!response.ok) {
          const error = await response.json();
          await openDrawer();
          showError(error.description || 'Unable to add item to cart');
          return;
        }

        await openDrawer();
      } catch (error) {
        console.error(error);
        showError('Unable to add item to cart');
      } finally {
        if (submitButton) submitButton.disabled = false;
        setLoading(false);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    const page = document.querySelector('[data-cart-page]');
    if (!page) return;

    const cartError = page.querySelector('[data-cart-error]');

    if (cartError && sessionStorage.getItem('cart_qty_clamped') === 'true') {
      sessionStorage.removeItem('cart_qty_clamped');
      cartError.hidden = false;
      setTimeout(() => { cartError.hidden = true; }, 6000);
    }

    page.querySelectorAll('[data-cart-quantity]').forEach((wrap) => {
      const input = wrap.querySelector('[data-cart-quantity-input]');
      const minus = wrap.querySelector('[data-cart-quantity-minus]');
      const plus = wrap.querySelector('[data-cart-quantity-plus]');
      if (!input) return;

      minus?.addEventListener('click', () => {
        const next = Math.max(0, parseInt(input.value, 10) - 1);
        input.value = String(next);
      });

      plus?.addEventListener('click', () => {
        const max = input.dataset.maxQuantity ? parseInt(input.dataset.maxQuantity, 10) : Infinity;
        const next = Math.min(max, parseInt(input.value, 10) + 1);
        input.value = String(next);
      });
    });

    const form = page.querySelector('[data-cart-form]');
    form?.addEventListener('submit', () => {
      let clamped = false;
      page.querySelectorAll('[data-cart-quantity-input]').forEach((input) => {
        const max = input.dataset.maxQuantity ? parseInt(input.dataset.maxQuantity, 10) : Infinity;
        const val = Math.min(max, Math.max(0, parseInt(input.value, 10) || 0));
        if (parseInt(input.value, 10) !== val) clamped = true;
        input.value = String(val);
      });
      if (clamped) sessionStorage.setItem('cart_qty_clamped', 'true');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-collection-page]');
    if (!section) return;

    const sortSelect = section.querySelector('[data-collection-sort]');
    const sortSelectDialog = section.querySelector('[data-collection-sort-dialog]');

    const navigateWithSort = (value) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      window.location.href = url.toString();
    };

    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        navigateWithSort(sortSelect.value);
      });
    }

    if (sortSelectDialog) {
      sortSelectDialog.addEventListener('change', () => {
        navigateWithSort(sortSelectDialog.value);
      });
    }

    const filterDialog = section.querySelector('[data-collection-filters-dialog]');
    const filterOpen = section.querySelector('[data-collection-filter-open]');
    const filterClose = section.querySelector('[data-collection-filter-close]');

    if (filterDialog && filterOpen) {
      const openFilters = () => {
        filterDialog.showModal();
        filterOpen.setAttribute('aria-expanded', 'true');
      };

      const closeFilters = () => {
        filterDialog.close();
        filterOpen.setAttribute('aria-expanded', 'false');
      };

      filterOpen.addEventListener('click', openFilters);
      if (filterClose) {
        filterClose.addEventListener('click', closeFilters);
      }

      filterDialog.addEventListener('click', (event) => {
        const rect = filterDialog.getBoundingClientRect();
        const clickedBackdrop =
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom;

        if (clickedBackdrop) {
          closeFilters();
        }
      });
    }

    const filterForms = section.querySelectorAll('[data-collection-filters-form]');
    let priceFilterTimer;

    const applyFilters = (form) => {
      const url = new URL(form.action || window.location.pathname, window.location.origin);
      const formData = new FormData(form);

      url.search = '';
      formData.forEach((value, key) => {
        if (value !== '') {
          url.searchParams.append(key, value);
        }
      });

      window.location.href = url.toString();
    };

    filterForms.forEach((form) => {
      form.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement)) return;
        if (target.type === 'checkbox') {
          applyFilters(form);
        }
      });

      form.addEventListener('input', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement) || target.type !== 'number') return;

        clearTimeout(priceFilterTimer);
        priceFilterTimer = window.setTimeout(() => {
          applyFilters(form);
        }, 600);
      });

      form.addEventListener('keydown', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement) || target.type !== 'number') return;
        if (event.key !== 'Enter') return;

        event.preventDefault();
        clearTimeout(priceFilterTimer);
        applyFilters(form);
      });
    });
  })();

  (function () {
    const section = document.querySelector('[data-collection-page]');
    if (!section) return;

    const searchInput = section.querySelector('[data-collection-search-input]');
    const searchClear = section.querySelector('[data-collection-search-clear]');
    const searchStatus = section.querySelector('[data-collection-search-status]');
    const gridDefault = section.querySelector('[data-collection-grid-default]');
    const gridSearch = section.querySelector('[data-collection-grid-search]');
    const searchList = section.querySelector('[data-collection-search-list]');
    const searchEmpty = section.querySelector('[data-collection-search-empty]');

    if (!searchInput || !gridDefault || !gridSearch || !searchList) return;

    const MIN_QUERY_LENGTH = 4;
    const DEBOUNCE_MS = 300;
    const URL_UPDATE_MS = 1000;

    const collectionHandle = section.dataset.collectionHandle;
    const hideSoldOut = section.dataset.hideSoldOut === 'true';
    const showVendor = section.dataset.showVendor === 'true';
    const showSaleBadge = section.dataset.showSaleBadge === 'true';
    const showAddToCart = section.dataset.showAddToCart === 'true';
    const saleLabel = section.dataset.saleLabel || 'Sale';
    const viewProductLabel = section.dataset.viewProductLabel || 'View product';
    const addToCartLabel = section.dataset.addToCartLabel || 'Add to cart';
    const soldOutLabel = section.dataset.soldOutLabel || 'Sold out';
    const minLengthMessage = section.dataset.searchMinLength || 'Enter at least 4 characters to search';
    const loadingMessage = section.dataset.searchLoading || 'Loading products…';

    let searchIndex = [];
    const searchIndexById = new Map();
    let cardHtmlCache = new Map();
    let catalogLoadPromise = null;
    let catalogFullyLoaded = false;
    let activeSearchQuery = '';
    let lastRenderedHandles = '';
    let searchTimer;
    let urlTimer;

    const formatMoney = (price) => {
      const cents = Math.round(parseFloat(price) * 100);

      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }

      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: 'USD',
      });
    };

    const getSearchQueryFromUrl = () => {
      return new URL(window.location.href).searchParams.get('q')?.trim() || '';
    };

    const updateSearchUrl = (query) => {
      const url = new URL(window.location.href);

      if (query) {
        url.searchParams.set('q', query);
      } else {
        url.searchParams.delete('q');
      }

      window.history.replaceState({}, '', url.toString());
    };

    const scheduleUrlUpdate = (query) => {
      clearTimeout(urlTimer);
      urlTimer = window.setTimeout(() => {
        updateSearchUrl(query);
      }, URL_UPDATE_MS);
    };

    const escapeHtml = (value) => {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    };

    const buildIndexEntry = (product) => {
      const variants = product.variants || [];
      const available = variants.some((variant) => variant.available);

      if (hideSoldOut && !available) {
        return null;
      }

      const variant = variants.find((v) => v.available) || variants[0] || null;
      const images = product.images || [];
      const image = images[0] || null;

      return {
        id: product.id,
        handle: product.handle,
        title: product.title,
        vendor: product.vendor,
        searchText: [product.title, product.vendor, product.product_type, ...(product.tags || [])]
          .filter(Boolean)
          .join(' ')
          .toLowerCase(),
        variantCount: variants.length,
        variant,
        image,
        onSale:
          variant &&
          variant.compare_at_price !== null &&
          Number(variant.compare_at_price) > Number(variant.price),
      };
    };

    const addProductsToIndex = (products) => {
      for (const product of products) {
        const entry = buildIndexEntry(product);
        if (!entry) continue;

        searchIndexById.set(entry.id, entry);
      }

      searchIndex = Array.from(searchIndexById.values());
    };

    const loadCatalog = () => {
      if (catalogFullyLoaded) {
        return Promise.resolve(searchIndex);
      }

      if (catalogLoadPromise) {
        return catalogLoadPromise;
      }

      catalogLoadPromise = (async () => {
        let page = 1;

        while (true) {
          const response = await fetch(
            `/collections/${encodeURIComponent(collectionHandle)}/products.json?limit=250&page=${page}`
          );

          if (!response.ok) {
            throw new Error('Failed to load collection products');
          }

          const data = await response.json();
          addProductsToIndex(data.products || []);

          if (activeSearchQuery.length >= MIN_QUERY_LENGTH) {
            const stillLoading = (data.products || []).length === 250;
            filterAndRender(activeSearchQuery, { loading: stillLoading });
          }

          if (!data.products || data.products.length < 250) {
            catalogFullyLoaded = true;
            break;
          }

          page += 1;
        }

        return searchIndex;
      })();

      return catalogLoadPromise;
    };

    const startCatalogPrefetch = () => {
      if (catalogFullyLoaded || catalogLoadPromise) return;
      loadCatalog().catch(() => {});
    };

    const buildProductCard = (entry) => {
      if (cardHtmlCache.has(entry.handle)) {
        return cardHtmlCache.get(entry.handle);
      }

      const variant = entry.variant;
      const productUrl = `/products/${entry.handle}`;

      let priceHtml = '';
      if (variant) {
        if (entry.onSale) {
          priceHtml = `
            <span class="collection-page__price--sale">${formatMoney(variant.price)}</span>
            <span class="collection-page__price--compare">${formatMoney(variant.compare_at_price)}</span>
          `;
        } else {
          priceHtml = `<span>${formatMoney(variant.price)}</span>`;
        }
      }

      let badgeHtml = '';
      if (showSaleBadge && entry.onSale) {
        badgeHtml = `<span class="collection-page__badge">${escapeHtml(saleLabel)}</span>`;
      }

      let vendorHtml = '';
      if (showVendor && entry.vendor) {
        vendorHtml = `<p class="collection-page__vendor">${escapeHtml(entry.vendor)}</p>`;
      }

      let actionHtml = '';
      if (showAddToCart && variant) {
        if (entry.variantCount === 1) {
          actionHtml = `
            <form method="post" action="/cart/add" class="collection-page__product-form">
              <input type="hidden" name="id" value="${variant.id}">
              <button type="submit" class="collection-page__button"${variant.available ? '' : ' disabled'}>
                ${escapeHtml(variant.available ? addToCartLabel : soldOutLabel)}
              </button>
            </form>
          `;
        } else {
          actionHtml = `
            <a href="${productUrl}" class="collection-page__button collection-page__button--link">
              ${escapeHtml(viewProductLabel)}
            </a>
          `;
        }
      }

      const imageHtml = entry.image
        ? `<img class="collection-page__image" src="${escapeHtml(entry.image.src)}" alt="${escapeHtml(entry.image.alt || entry.title)}" loading="lazy" width="900" height="900">`
        : '';

      const html = `
        <li class="collection-page__item">
          <article class="collection-page__card">
            <div class="collection-page__card-media">
              <a href="${productUrl}" class="collection-page__card-link">
                ${imageHtml}
              </a>
              ${badgeHtml}
            </div>
            <div class="collection-page__card-body">
              ${vendorHtml}
              <h3 class="collection-page__product-title">
                <a href="${productUrl}" class="collection-page__card-link">${escapeHtml(entry.title)}</a>
              </h3>
              <p class="collection-page__price">${priceHtml}</p>
              ${actionHtml}
            </div>
          </article>
        </li>
      `;

      cardHtmlCache.set(entry.handle, html);
      return html;
    };

    const showDefaultGrid = () => {
      gridDefault.hidden = false;
      gridSearch.hidden = true;
      searchEmpty.hidden = true;
      lastRenderedHandles = '';

      if (searchStatus) {
        searchStatus.hidden = true;
        searchStatus.textContent = '';
      }
    };

    const showMinLengthHint = () => {
      gridDefault.hidden = false;
      gridSearch.hidden = true;
      searchEmpty.hidden = true;
      lastRenderedHandles = '';

      if (searchStatus) {
        searchStatus.textContent = minLengthMessage;
        searchStatus.hidden = false;
      }
    };

    const showLoadingStatus = () => {
      if (!searchStatus) return;

      searchStatus.textContent = loadingMessage;
      searchStatus.hidden = false;
    };

    const renderResults = (results, { loading = false } = {}) => {
      const handlesKey = results.map((entry) => entry.handle).join('|');

      gridDefault.hidden = true;
      gridSearch.hidden = false;

      if (handlesKey !== lastRenderedHandles) {
        lastRenderedHandles = handlesKey;

        if (results.length === 0) {
          searchList.innerHTML = '';
          searchEmpty.hidden = !catalogFullyLoaded;
        } else {
          searchEmpty.hidden = true;
          searchList.innerHTML = results.map((entry) => buildProductCard(entry)).join('');
        }
      } else if (results.length === 0) {
        searchEmpty.hidden = !catalogFullyLoaded;
      }

      if (searchStatus) {
        if (loading && !catalogFullyLoaded) {
          searchStatus.textContent = loadingMessage;
        } else if (results.length === 0 && catalogFullyLoaded) {
          searchStatus.hidden = true;
        } else {
          const template =
            results.length === 1
              ? section.dataset.searchResultsOne
              : section.dataset.searchResultsOther;
          searchStatus.textContent = template.replace('[[ count ]]', String(results.length));
        }
        searchStatus.hidden = false;
      }
    };

    const filterIndex = (query) => {
      const normalizedQuery = query.toLowerCase().trim();
      return searchIndex.filter((entry) => entry.searchText.includes(normalizedQuery));
    };

    const filterAndRender = (query, options = {}) => {
      const results = filterIndex(query);
      renderResults(results, options);
    };

    const runSearch = async (query, { updateUrl = false } = {}) => {
      const trimmedQuery = query.trim();
      activeSearchQuery = trimmedQuery;

      clearTimeout(urlTimer);

      if (!trimmedQuery) {
        showDefaultGrid();
        updateSearchUrl('');
        if (searchClear) searchClear.hidden = true;
        return;
      }

      if (searchClear) searchClear.hidden = false;

      if (trimmedQuery.length < MIN_QUERY_LENGTH) {
        showMinLengthHint();
        if (updateUrl) {
          updateSearchUrl('');
        }
        return;
      }

      gridDefault.hidden = true;
      gridSearch.hidden = false;
      showLoadingStatus();

      try {
        await loadCatalog();

        if (activeSearchQuery !== trimmedQuery) return;

        filterAndRender(trimmedQuery, { loading: !catalogFullyLoaded });

        if (updateUrl) {
          updateSearchUrl(trimmedQuery);
        } else {
          scheduleUrlUpdate(trimmedQuery);
        }
      } catch (error) {
        if (activeSearchQuery !== trimmedQuery) return;

        if (searchStatus) {
          searchStatus.textContent = section.dataset.searchError || 'Unable to search right now.';
          searchStatus.hidden = false;
        }
      }
    };

    const scheduleSearch = (query) => {
      clearTimeout(searchTimer);
      searchTimer = window.setTimeout(() => {
        runSearch(query, { updateUrl: false });
      }, DEBOUNCE_MS);
    };

    const searchForm = section.querySelector('[data-collection-search-form]');

    const runSearchNow = () => {
      clearTimeout(searchTimer);
      runSearch(searchInput.value, { updateUrl: true });
    };

    searchInput.addEventListener('focus', startCatalogPrefetch);

    searchInput.addEventListener('input', () => {
      const value = searchInput.value;

      if (!value.trim()) {
        runSearch('', { updateUrl: false });
        return;
      }

      if (value.trim().length < MIN_QUERY_LENGTH) {
        clearTimeout(searchTimer);
        showMinLengthHint();
        if (searchClear) searchClear.hidden = false;
        return;
      }

      scheduleSearch(value);
    });

    searchInput.addEventListener('search', () => {
      runSearchNow();
    });

    searchInput.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;

      event.preventDefault();
      runSearchNow();
    });

    if (searchForm) {
      searchForm.addEventListener('submit', (event) => {
        event.preventDefault();
        runSearchNow();
      });
    }

    if (searchClear) {
      searchClear.addEventListener('click', () => {
        searchInput.value = '';
        runSearch('', { updateUrl: true });
        searchInput.focus();
      });
    }

    const initialQuery = getSearchQueryFromUrl();
    if (initialQuery) {
      searchInput.value = initialQuery;
      if (searchClear) searchClear.hidden = false;
      runSearch(initialQuery, { updateUrl: false });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-carousel-accent"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-content-accent]');
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    sections.forEach((section) => {
      const contentTrack = section.querySelector('[data-content-accent-content]');
      const mediaTrack = section.querySelector('[data-content-accent-media]');
      const prevButton = section.querySelector('[data-content-accent-prev]');
      const nextButton = section.querySelector('[data-content-accent-next]');

      if (!contentTrack || !mediaTrack) return;

      const contentSlides = Array.from(section.querySelectorAll('[data-content-accent-slide]'));
      const mediaSlides = Array.from(section.querySelectorAll('[data-content-accent-media-slide]'));

      if (contentSlides.length === 0) return;

      let activeIndex = 0;
      let isSyncing = false;

      const isMobile = () => mobileQuery.matches;

      const readMoreLabel = section.dataset.readMoreLabel || 'Read more';
      const readLessLabel = section.dataset.readLessLabel || 'Read less';

      const collapseEntry = (wrap) => {
        if (!wrap) return;
        const body = wrap.querySelector('[data-content-accent-entry-body]');
        const button = wrap.querySelector('[data-content-accent-read-more]');
        if (!body || !button) return;

        body.classList.remove('is-expanded');
        button.setAttribute('aria-expanded', 'false');
        button.textContent = readMoreLabel;
      };

      const updateEntry = (wrap) => {
        if (!wrap) return;
        const body = wrap.querySelector('[data-content-accent-entry-body]');
        const button = wrap.querySelector('[data-content-accent-read-more]');
        if (!body || !button) return;

        if (body.classList.contains('is-expanded')) {
          button.hidden = false;
          return;
        }

        button.hidden = true;
        void body.offsetHeight;

        if (body.scrollHeight > body.clientHeight + 1) {
          button.hidden = false;
        }
      };

      const updateVisibleEntries = () => {
        contentSlides.forEach((slide, slideIndex) => {
          const wrap = slide.querySelector('[data-content-accent-entry]');
          if (!wrap) return;

          const isVisible = isMobile()
            ? slide.classList.contains('is-active')
            : slideIndex === activeIndex;

          if (!isVisible) {
            collapseEntry(wrap);
            return;
          }

          updateEntry(wrap);
        });
      };

      section.querySelectorAll('[data-content-accent-read-more]').forEach((button) => {
        button.addEventListener('click', () => {
          const wrap = button.closest('[data-content-accent-entry]');
          const body = wrap?.querySelector('[data-content-accent-entry-body]');
          if (!body) return;

          const isExpanded = body.classList.toggle('is-expanded');
          button.setAttribute('aria-expanded', String(isExpanded));
          button.textContent = isExpanded ? readLessLabel : readMoreLabel;
          button.hidden = false;
        });
      });

      const setActiveContentSlide = (index) => {
        contentSlides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === index);
          if (slideIndex !== index) {
            collapseEntry(slide.querySelector('[data-content-accent-entry]'));
          }
        });

        requestAnimationFrame(updateVisibleEntries);
      };

      const scrollToIndex = (index, behavior) => {
        const safeIndex = Math.max(0, Math.min(index, contentSlides.length - 1));
        activeIndex = safeIndex;

        const contentSlide = contentSlides[safeIndex];
        const mediaSlide = mediaSlides[safeIndex];

        const scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : behavior || 'smooth';

        isSyncing = true;
        setActiveContentSlide(safeIndex);

        if (isMobile()) {
          if (mediaSlide) {
            mediaTrack.scrollTo({
              left: mediaSlide.offsetLeft,
              behavior: scrollBehavior,
            });
          }
        } else {
          if (contentSlide) {
            contentTrack.scrollTo({
              left: contentSlide.offsetLeft,
              behavior: scrollBehavior,
            });
          }

          if (mediaSlide) {
            mediaTrack.scrollTo({
              left: mediaSlide.offsetLeft,
              behavior: scrollBehavior,
            });
          }
        }

        window.setTimeout(() => {
          isSyncing = false;
          updateButtons();
        }, scrollBehavior === 'smooth' ? 350 : 0);
      };

      const updateButtons = () => {
        if (prevButton) prevButton.disabled = activeIndex <= 0;
        if (nextButton) nextButton.disabled = activeIndex >= contentSlides.length - 1;
      };

      const syncFromMediaScroll = () => {
        if (isSyncing) return;

        const scrollLeft = mediaTrack.scrollLeft;
        let closestIndex = 0;
        let closestDistance = Infinity;

        mediaSlides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        if (closestIndex !== activeIndex) {
          scrollToIndex(closestIndex, 'auto');
        } else {
          updateButtons();
        }
      };

      const syncFromContentScroll = () => {
        if (isSyncing || isMobile()) return;

        const scrollLeft = contentTrack.scrollLeft;
        let closestIndex = 0;
        let closestDistance = Infinity;

        contentSlides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        if (closestIndex !== activeIndex) {
          scrollToIndex(closestIndex, 'auto');
        } else {
          updateButtons();
        }
      };

      const handleLayoutChange = () => {
        scrollToIndex(activeIndex, 'auto');
        requestAnimationFrame(updateVisibleEntries);
      };

      prevButton?.addEventListener('click', () => scrollToIndex(activeIndex - 1));
      nextButton?.addEventListener('click', () => scrollToIndex(activeIndex + 1));

      contentTrack.addEventListener('scroll', syncFromContentScroll, { passive: true });
      mediaTrack.addEventListener('scroll', syncFromMediaScroll, { passive: true });

      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', handleLayoutChange);
      } else {
        mobileQuery.addListener(handleLayoutChange);
      }

      window.addEventListener('resize', handleLayoutChange);
      setActiveContentSlide(0);
      updateButtons();
      requestAnimationFrame(updateVisibleEntries);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["favorites-global"]) return;
  try {
    
  (function () {
    const STORAGE_KEY = 'theme:favorites';
    const root = window.Shopify?.routes?.root || '/';

    const readHandles = () => {
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        const parsed = stored ? JSON.parse(stored) : [];
        return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
      } catch {
        return [];
      }
    };

    const writeHandles = (handles) => {
      const unique = [...new Set(handles.filter(Boolean))];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(unique));
      document.dispatchEvent(new CustomEvent('favorites:updated', { detail: { handles: unique } }));
      return unique;
    };

    const isFavorite = (handle) => readHandles().includes(handle);

    const toggleFavorite = (handle) => {
      if (!handle) return readHandles();
      const handles = readHandles();
      const index = handles.indexOf(handle);
      if (index === -1) {
        handles.push(handle);
      } else {
        handles.splice(index, 1);
      }
      return writeHandles(handles);
    };

    const updateCounts = () => {
      const count = readHandles().length;
      document.querySelectorAll('[data-favorites-count]').forEach((element) => {
        element.textContent = String(count);
        element.hidden = count === 0;
      });
    };

    const updateButtons = () => {
      document.querySelectorAll('[data-favorites-toggle]').forEach((button) => {
        const handle = button.dataset.productHandle;
        const active = isFavorite(handle);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');

        const addLabel = button.dataset.labelAdd;
        const removeLabel = button.dataset.labelRemove;
        if (addLabel && removeLabel) {
          button.setAttribute('aria-label', active ? removeLabel : addLabel);
        }
      });
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-favorites-toggle]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      toggleFavorite(button.dataset.productHandle);
      updateCounts();
      updateButtons();
    });

    document.addEventListener('favorites:updated', () => {
      updateCounts();
      updateButtons();
    });

    const formatMoney = (cents, format) => {
      if (typeof window.Shopify?.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, format);
      }

      const amount = (Number(cents) / 100).toFixed(2);
      return format ? format.replace(/\{\{\s*amount\s*\}\}/, amount) : `$${amount}`;
    };

    const escapeHtml = (value) =>
      String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

    const heartIconMarkup = `
      <svg class="favorites-button__icon favorites-button__icon--outline" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 20.25s-7.5-4.35-7.5-10.125a4.125 4.125 0 0 1 7.5-2.25 4.125 4.125 0 0 1 7.5 2.25C19.5 15.9 12 20.25 12 20.25Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
      </svg>
      <svg class="favorites-button__icon favorites-button__icon--filled" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 20.25s-7.5-4.35-7.5-10.125a4.125 4.125 0 0 1 7.5-2.25 4.125 4.125 0 0 1 7.5 2.25C19.5 15.9 12 20.25 12 20.25Z" fill="currentColor"/>
      </svg>
    `;

    const productJsonUrl = (handle) => {
      const base = root.endsWith('/') ? root : `${root}/`;
      return `${base}products/${encodeURIComponent(handle)}.js`;
    };

    const renderFavoritesPage = async (page) => {
      const grid = page.querySelector('[data-favorites-grid]');
      const emptyState = page.querySelector('[data-favorites-empty]');
      if (!grid || !emptyState) return;

      const handles = readHandles();
      const moneyFormat = page.dataset.moneyFormat;
      const strings = {
        sale: page.dataset.labelSale || 'Sale',
        regularPrice: page.dataset.labelRegularPrice || 'Regular price',
        addToCart: page.dataset.labelAddToCart || 'Add to cart',
        soldOut: page.dataset.labelSoldOut || 'Sold out',
        viewProduct: page.dataset.labelViewProduct || 'View product',
        remove: page.dataset.labelRemove || 'Remove from favorites',
        add: page.dataset.labelAdd || 'Add to favorites',
        removeButton: page.dataset.labelRemoveButton || 'Remove',
      };

      grid.innerHTML = '';

      if (handles.length === 0) {
        emptyState.hidden = false;
        return;
      }

      emptyState.hidden = true;

      const results = await Promise.all(
        handles.map(async (handle) => {
          try {
            const response = await fetch(productJsonUrl(handle));
            if (response.status === 404) {
              return { handle, product: null, notFound: true };
            }
            if (!response.ok) {
              return { handle, product: null, notFound: false };
            }
            return { handle, product: await response.json(), notFound: false };
          } catch {
            return { handle, product: null, notFound: false };
          }
        })
      );

      const notFoundHandles = results.filter((result) => result.notFound).map((result) => result.handle);
      if (notFoundHandles.length > 0) {
        writeHandles(handles.filter((handle) => !notFoundHandles.includes(handle)));
      }

      const validProducts = results.map((result) => result.product).filter(Boolean);

      if (validProducts.length === 0) {
        emptyState.hidden = false;
        return;
      }

      validProducts.forEach((product) => {
        const variant = product.variants.find((entry) => entry.available) || product.variants[0];
        if (!variant) return;

        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        const image = product.featured_image || product.images?.[0] || '';
        const productUrl = `${root}products/${product.handle}`;
        const title = escapeHtml(product.title);
        const item = document.createElement('li');
        item.className = 'favorites-page__item';

        const priceMarkup = onSale
          ? `<span class="favorites-page__price--sale">${formatMoney(variant.price, moneyFormat)}</span>
             <span class="favorites-page__price--compare">
               <span class="visually-hidden">${escapeHtml(strings.regularPrice)}</span>
               ${formatMoney(variant.compare_at_price, moneyFormat)}
             </span>`
          : `<span>${formatMoney(variant.price, moneyFormat)}</span>`;

        let actionMarkup = '';
        if (page.dataset.showAddToCart === 'true') {
          if (product.variants.length === 1) {
            actionMarkup = `
              <form method="post" action="${root}cart/add" class="favorites-page__product-form" accept-charset="UTF-8">
                <input type="hidden" name="id" value="${variant.id}">
                <button type="submit" class="favorites-page__button"${variant.available ? '' : ' disabled'}>
                  ${variant.available ? escapeHtml(strings.addToCart) : escapeHtml(strings.soldOut)}
                </button>
              </form>
            `;
          } else {
            actionMarkup = `
              <a href="${productUrl}" class="favorites-page__button favorites-page__button--link">
                ${escapeHtml(strings.viewProduct)}
              </a>
            `;
          }
        }

        const removeMarkup = `
          <button
            type="button"
            class="favorites-page__remove"
            data-favorites-toggle
            data-product-handle="${escapeHtml(product.handle)}"
            data-product-id="${product.id}"
            data-label-add="${escapeHtml(strings.add)}"
            data-label-remove="${escapeHtml(strings.remove)}"
            aria-label="${escapeHtml(strings.remove)}"
          >
            ${escapeHtml(strings.removeButton)}
          </button>
        `;

        item.innerHTML = `
          <article class="favorites-page__card">
            <div class="favorites-page__card-media">
              <a href="${productUrl}" class="favorites-page__card-link">
                ${image ? `<img src="${image}" alt="${title}" class="favorites-page__image" loading="lazy" width="900" height="900">` : ''}
              </a>
              ${onSale ? `<span class="favorites-page__badge">${escapeHtml(strings.sale)}</span>` : ''}
              <button
                type="button"
                class="favorites-button favorites-button--card is-active"
                data-favorites-toggle
                data-product-handle="${escapeHtml(product.handle)}"
                data-product-id="${product.id}"
                data-label-add="${escapeHtml(strings.add)}"
                data-label-remove="${escapeHtml(strings.remove)}"
                aria-pressed="true"
                aria-label="${escapeHtml(strings.remove)}"
              >
                ${heartIconMarkup}
              </button>
            </div>
            <div class="favorites-page__card-body">
              <h3 class="favorites-page__product-title">
                <a href="${productUrl}" class="favorites-page__card-link">${title}</a>
              </h3>
              <p class="favorites-page__price">${priceMarkup}</p>
              <div class="favorites-page__actions">
                ${actionMarkup}
                ${removeMarkup}
              </div>
            </div>
          </article>
        `;

        grid.appendChild(item);
      });

      updateButtons();
    };

    const init = () => {
      updateCounts();
      updateButtons();

      document.querySelectorAll('[data-favorites-toggle]').forEach((button) => {
        if (!button.dataset.labelAdd) {
          button.dataset.labelAdd = button.getAttribute('aria-label') || 'Add to favorites';
        }
        if (!button.dataset.labelRemove) {
          button.dataset.labelRemove = 'Remove from favorites';
        }
      });

      const page = document.querySelector('[data-favorites-page]');
      if (page) {
        renderFavoritesPage(page);
        document.addEventListener('favorites:updated', () => {
          renderFavoritesPage(page);
        });
      }
    };

    window.themeFavorites = {
      getHandles: readHandles,
      toggle: toggleFavorite,
      isFavorite,
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const wrapper = document.querySelector('[data-header]');
    if (!wrapper) return;

    const header = wrapper.querySelector('.site-header');
    const threshold = parseInt(wrapper.dataset.scrollThreshold, 10) || 50;
    const mobileMenu = wrapper.querySelector('[data-header-mobile-menu]');
    const menuToggle = wrapper.querySelector('[data-header-menu-toggle]');
    const menuClose = wrapper.querySelector('[data-header-menu-close]');

    const syncAnnouncementOverlay = () => {
      if (!wrapper.classList.contains('site-header-wrapper--overlay')) return;

      const spacer = wrapper.querySelector('[data-announcement-spacer]');
      const announcementBar = wrapper.querySelector('.site-header__announcement--above-hero');

      if (!announcementBar || announcementBar.hidden) {
        wrapper.style.setProperty('--announcement-height', '0px');
        if (spacer) spacer.style.height = '0px';
        return;
      }

      const height = `${announcementBar.offsetHeight}px`;
      wrapper.style.setProperty('--announcement-height', height);
      if (spacer) spacer.style.height = height;
    };

    const syncHeaderLayout = () => {
      syncAnnouncementOverlay();
      syncFixedHeaderOffset();
    };

    const syncFixedHeaderOffset = () => {
      if (!wrapper.hasAttribute('data-header-fixed')) return;

      const height = wrapper.offsetHeight;
      document.documentElement.style.setProperty('--site-header-offset', `${height}px`);
      document.body.style.paddingTop = `${height}px`;
    };

    const updateScrollState = () => {
      if (wrapper.hasAttribute('data-header-fixed')) {
        header.classList.add('site-header--scrolled');
        return;
      }

      const scrolled = window.scrollY > threshold;
      header.classList.toggle('site-header--scrolled', scrolled);
    };

    syncHeaderLayout();
    updateScrollState();
    window.addEventListener('resize', syncHeaderLayout);
    window.addEventListener('scroll', updateScrollState, { passive: true });

    const announcement = wrapper.querySelector('[data-announcement-bar]');
    const announcementDismissKey = 'theme:announcement-dismissed';

    if (announcement) {
      if (localStorage.getItem(announcementDismissKey) === 'true') {
        announcement.hidden = true;
        syncHeaderLayout();
      }

      const dismissButton = announcement.querySelector('[data-announcement-dismiss]');
      if (dismissButton) {
        dismissButton.addEventListener('click', () => {
          announcement.hidden = true;
          localStorage.setItem(announcementDismissKey, 'true');
          syncHeaderLayout();
        });
      }

      const slides = [...announcement.querySelectorAll('[data-announcement-slide]')];
      const shouldAutoplay =
        announcement.dataset.announcementAutoplay === 'true' &&
        slides.length > 1 &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (slides.length > 0) {
        let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (activeIndex === -1) activeIndex = 0;

        slides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === activeIndex);
        });

        if (shouldAutoplay) {
          const interval = parseInt(announcement.dataset.announcementInterval, 10) || 5000;

          window.setInterval(() => {
            slides[activeIndex].classList.remove('is-active');
            activeIndex = (activeIndex + 1) % slides.length;
            slides[activeIndex].classList.add('is-active');
          }, interval);
        }
      }
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncHeaderLayout);
    }

    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(syncHeaderLayout);
      resizeObserver.observe(wrapper);

      const announcementBar = wrapper.querySelector('.site-header__announcement--above-hero');
      if (announcementBar) resizeObserver.observe(announcementBar);
    }

    if (mobileMenu && menuToggle) {
      const openMenu = () => {
        mobileMenu.showModal();
        mobileMenu.setAttribute('scroll-lock', '');
        menuToggle.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      };

      const closeMenu = () => {
        mobileMenu.close();
        mobileMenu.removeAttribute('scroll-lock');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      };

      menuToggle.addEventListener('click', openMenu);
      menuClose?.addEventListener('click', closeMenu);
      mobileMenu.addEventListener('click', (event) => {
        if (event.target === mobileMenu) closeMenu();
      });
      mobileMenu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', closeMenu);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-product-page]');

    sections.forEach((section) => {
      const form = section.querySelector('[data-product-form]');
      if (!form) return;

      const variantsJson = section.querySelector('[data-product-variants-json]');
      if (!variantsJson) return;

      const variants = JSON.parse(variantsJson.textContent);
      const variantInput = form.querySelector('[data-product-variant-id]');
      const priceCurrent = section.querySelector('[data-product-price-current]');
      const priceCompare = section.querySelector('[data-product-price-compare]');
      const saleBadge = section.querySelector('[data-product-sale-badge]');
      const submitButton = section.querySelector('[data-product-submit]');
      const submitLabel = section.querySelector('[data-product-submit-label]');
      const skuEl = section.querySelector('[data-product-sku] span');
      const mediaViewer = section.querySelector('[data-product-media-viewer]');
      const thumbs = section.querySelectorAll('[data-product-thumb]');
      const quantityInput = form.querySelector('[data-quantity-input]');
      const optionInputs = form.querySelectorAll('[data-product-option-input]');

      const info = section.querySelector('[data-product-info]');
      const moneyFormat = info?.dataset.moneyFormat;

      const formatMoney = (cents) => {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
          return window.Shopify.formatMoney(cents, moneyFormat);
        }
        return (cents / 100).toFixed(2);
      };

      const getSelectedOptions = () => {
        const options = [];
        section.querySelectorAll('[data-product-option]').forEach((fieldset) => {
          const checked = fieldset.querySelector('[data-product-option-input]:checked');
          if (checked) options.push(checked.value);
        });
        return options;
      };

      const findVariant = () => {
        const selected = getSelectedOptions();
        return variants.find((variant) => {
          return variant.options.every((option, index) => option === selected[index]);
        });
      };

      const updateOptionLabels = () => {
        section.querySelectorAll('[data-product-option]').forEach((fieldset) => {
          const checked = fieldset.querySelector('[data-product-option-input]:checked');
          const display = fieldset.querySelector('[data-option-value-display]');
          if (checked && display) display.textContent = checked.value;
        });
      };

      const pauseMedia = (container) => {
        container.querySelectorAll('video').forEach((video) => {
          video.pause();
        });
      };

      const setMainMedia = (mediaId) => {
        if (!mediaViewer) return;

        mediaViewer.querySelectorAll('[data-product-media-item]').forEach((item) => {
          const isActive = Number(item.dataset.mediaId) === mediaId;

          if (isActive) {
            item.removeAttribute('hidden');
          } else {
            item.setAttribute('hidden', '');
            pauseMedia(item);
          }
        });

        thumbs.forEach((thumb) => {
          const isActive = Number(thumb.dataset.mediaId) === mediaId;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      const updateVariant = (variant) => {
        if (!variant) return;

        variantInput.value = variant.id;

        if (priceCurrent) {
          priceCurrent.textContent = formatMoney(variant.price);
        }

        if (priceCompare) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceCompare.textContent = formatMoney(variant.compare_at_price);
            priceCompare.hidden = false;
            if (priceCurrent) priceCurrent.style.color = '';
            if (saleBadge) saleBadge.hidden = false;
          } else {
            priceCompare.hidden = true;
            if (saleBadge) saleBadge.hidden = true;
          }
        }

        if (submitButton) {
          submitButton.disabled = !variant.available;
        }

        if (submitLabel) {
          const availableLabel = info?.dataset.labelAvailable || 'Add to cart';
          const soldOutLabel = info?.dataset.labelSoldOut || 'Sold out';
          submitLabel.textContent = variant.available ? availableLabel : soldOutLabel;
        }

        if (skuEl) {
          skuEl.textContent = variant.sku || '';
        }

        if (quantityInput) {
          if (variant.inventory_management && variant.inventory_quantity >= 0) {
            quantityInput.max = variant.inventory_quantity;
            quantityInput.dataset.maxQuantity = String(variant.inventory_quantity);
            if (parseInt(quantityInput.value, 10) > variant.inventory_quantity) {
              quantityInput.value = String(Math.max(1, variant.inventory_quantity));
            }
          } else {
            quantityInput.removeAttribute('max');
          }
        }

        if (variant.featured_media && variant.featured_media.id) {
          setMainMedia(variant.featured_media.id);
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      };

      optionInputs.forEach((input) => {
        input.addEventListener('change', () => {
          updateOptionLabels();
          const variant = findVariant();
          if (variant) updateVariant(variant);
        });
      });

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          setMainMedia(Number(thumb.dataset.mediaId));
        });
      });

      quantityInput?.addEventListener('change', () => {
        const max = quantityInput.dataset.maxQuantity ? parseInt(quantityInput.dataset.maxQuantity, 10) : Infinity;
        const val = parseInt(quantityInput.value, 10) || 1;
        quantityInput.value = String(Math.max(1, Math.min(max, val)));
      });

      section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
        if (!quantityInput) return;
        const next = Math.max(1, parseInt(quantityInput.value, 10) - 1);
        quantityInput.value = String(next);
      });

      section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
        if (!quantityInput) return;
        const max = quantityInput.dataset.maxQuantity ? parseInt(quantityInput.dataset.maxQuantity, 10) : Infinity;
        const next = Math.min(max, Math.max(1, parseInt(quantityInput.value, 10) + 1));
        quantityInput.value = String(next);
      });

      form.addEventListener('submit', () => {
        const max = quantityInput?.dataset.maxQuantity ? parseInt(quantityInput.dataset.maxQuantity, 10) : Infinity;
        const val = parseInt(quantityInput?.value, 10) || 1;
        if (val > max) quantityInput.value = String(Math.max(1, max));
      });

      const initialVariant = variants.find((variant) => String(variant.id) === String(variantInput.value));
      if (initialVariant) {
        updateOptionLabels();
        updateVariant(initialVariant);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-sale-countdown]');
    if (!section) return;

    function setVH() {
      document.documentElement.style.setProperty('--100vh', window.innerHeight / 100 + 'px');
    }
    setVH();
    window.addEventListener('resize', setVH);

    const target = parseInt(section.getAttribute('data-target'), 10);
    if (isNaN(target)) return;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function update() {
      const now = Date.now();
      const remaining = target - now;

      const daysSpan = section.querySelector('[data-countdown-days]');
      const hoursSpan = section.querySelector('[data-countdown-hours]');
      const minutesSpan = section.querySelector('[data-countdown-minutes]');
      const secondsSpan = section.querySelector('[data-countdown-seconds]');
      const timer = section.querySelector('[data-sale-countdown-timer]');
      const started = section.querySelector('[data-sale-countdown-started]');

      if (remaining <= 0) {
        if (timer) timer.hidden = true;
        if (started) started.hidden = false;
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (daysSpan) daysSpan.textContent = pad(days);
      if (hoursSpan) hoursSpan.textContent = pad(hours);
      if (minutesSpan) minutesSpan.textContent = pad(minutes);
      if (secondsSpan) secondsSpan.textContent = pad(seconds);
    }

    update();
    setInterval(update, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    const page = document.querySelector('[data-search-page]');
    if (!page) return;

    const sortSelect = page.querySelector('[data-search-sort]');
    const sortSelectDialog = page.querySelector('[data-search-sort-dialog]');

    const navigateWithSort = (value) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      window.location.href = url.toString();
    };

    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        navigateWithSort(sortSelect.value);
      });
    }

    if (sortSelectDialog) {
      sortSelectDialog.addEventListener('change', () => {
        navigateWithSort(sortSelectDialog.value);
      });
    }

    const filterDialog = page.querySelector('[data-search-filters-dialog]');
    const filterOpen = page.querySelector('[data-search-filter-open]');
    const filterClose = page.querySelector('[data-search-filter-close]');

    if (filterDialog && filterOpen) {
      const openFilters = () => {
        filterDialog.showModal();
        filterOpen.setAttribute('aria-expanded', 'true');
      };

      const closeFilters = () => {
        filterDialog.close();
        filterOpen.setAttribute('aria-expanded', 'false');
      };

      filterOpen.addEventListener('click', openFilters);
      if (filterClose) {
        filterClose.addEventListener('click', closeFilters);
      }

      filterDialog.addEventListener('click', (event) => {
        const rect = filterDialog.getBoundingClientRect();
        const clickedBackdrop =
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom;

        if (clickedBackdrop) {
          closeFilters();
        }
      });
    }

    const filterForms = page.querySelectorAll('[data-search-filters-form]');
    let priceFilterTimer;

    const applyFilters = (form) => {
      const url = new URL(form.action || window.location.pathname, window.location.origin);
      const formData = new FormData(form);

      url.search = '';
      formData.forEach((value, key) => {
        if (value !== '') {
          url.searchParams.append(key, value);
        }
      });

      window.location.href = url.toString();
    };

    filterForms.forEach((form) => {
      form.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement)) return;
        if (target.type === 'checkbox') {
          applyFilters(form);
        }
      });

      form.addEventListener('input', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement) || target.type !== 'number') return;

        clearTimeout(priceFilterTimer);
        priceFilterTimer = window.setTimeout(() => {
          applyFilters(form);
        }, 600);
      });

      form.addEventListener('keydown', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement) || target.type !== 'number') return;
        if (event.key !== 'Enter') return;

        event.preventDefault();
        clearTimeout(priceFilterTimer);
        applyFilters(form);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-category-carousel]');

    sections.forEach((carousel) => {
      const section = carousel.closest('.shop-category');
      if (!section) return;

      const track = carousel.querySelector('[data-category-carousel-track]');
      const prevButton = section.querySelector('[data-category-carousel-prev]');
      const nextButton = section.querySelector('[data-category-carousel-next]');
      const items = carousel.querySelectorAll('.shop-category__item');

      if (!track || items.length === 0) return;

      const isCarouselMode = () => {
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        if (mobile) {
          return section.classList.contains('shop-category--mobile-carousel');
        }
        return section.classList.contains('shop-category--desktop-carousel');
      };

      const getScrollAmount = () => {
        const item = items[0];
        if (!item) return track.clientWidth;
        const styles = getComputedStyle(track.querySelector('.shop-category__list'));
        const gap = parseFloat(styles.columnGap || styles.gap || 0);
        return item.offsetWidth + gap;
      };

      const updateButtons = () => {
        if (!isCarouselMode()) {
          if (prevButton) prevButton.disabled = true;
          if (nextButton) nextButton.disabled = true;
          return;
        }

        const maxScroll = track.scrollWidth - track.clientWidth;
        if (prevButton) prevButton.disabled = track.scrollLeft <= 1;
        if (nextButton) nextButton.disabled = track.scrollLeft >= maxScroll - 1;
      };

      const scrollByStep = (direction) => {
        track.scrollBy({
          left: getScrollAmount() * direction,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      };

      prevButton?.addEventListener('click', () => scrollByStep(-1));
      nextButton?.addEventListener('click', () => scrollByStep(1));
      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trending-now"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const carousels = document.querySelectorAll('[data-trending-carousel]');

    carousels.forEach((carousel) => {
      const section = carousel.closest('.trending');
      if (!section) return;

      const track = carousel.querySelector('[data-trending-track]');
      const prevButton = section.querySelector('[data-trending-prev]');
      const nextButton = section.querySelector('[data-trending-next]');
      const items = carousel.querySelectorAll('.trending__item');

      if (!track || items.length === 0) return;

      const isCarouselMode = () => {
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        if (mobile) {
          return section.classList.contains('trending--mobile-carousel');
        }
        return section.classList.contains('trending--desktop-carousel');
      };

      const getScrollAmount = () => {
        const item = items[0];
        if (!item) return track.clientWidth;
        const list = track.querySelector('.trending__list');
        const styles = getComputedStyle(list);
        const gap = parseFloat(styles.columnGap || styles.gap || 0);
        return item.offsetWidth + gap;
      };

      const updateButtons = () => {
        if (!isCarouselMode()) {
          if (prevButton) prevButton.disabled = true;
          if (nextButton) nextButton.disabled = true;
          return;
        }

        const maxScroll = track.scrollWidth - track.clientWidth;
        if (prevButton) prevButton.disabled = track.scrollLeft <= 1;
        if (nextButton) nextButton.disabled = track.scrollLeft >= maxScroll - 1;
      };

      const scrollByStep = (direction) => {
        track.scrollBy({
          left: getScrollAmount() * direction,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      };

      prevButton?.addEventListener('click', () => scrollByStep(-1));
      nextButton?.addEventListener('click', () => scrollByStep(1));
      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
